import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#202020",
      "fill-rule": "evenodd",
      d: "M15.267 18.1.784 32.538l.266.179c.65.37 1.452.377 2.106.014l17.213-9.543zM0 30.407l13.806-13.765L0 2.876zm29.176-15.715-6.744-3.74-5.705 5.69 5.52 5.505 6.929-3.841a2.07 2.07 0 0 0 1.075-1.807c0-.75-.41-1.438-1.075-1.807M1.05.282.63.596l14.636 14.59 5.288-5.272L3.155.268A2.15 2.15 0 0 0 1.05.282",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }